export default {
  'approvalFiltersUserExtraFields.form.row': 'User extra field filter',
  'approvalFiltersUserExtraFields.form.addRow': 'Add user extra field filter',
  'approvalFiltersUserExtraFields.form.noRows':
    'No user extra field filters yet. Add at least one.',
};
